
import React from 'react';
import './ProgressStepper.css';

const ProgressStepper = ({
    isCompleted,
    isValidationCompleted,
    isFraudAnalysisCompleted,
    isTriagingCompleted,
    isClaimsSetUpCompleted,
    currentStep,
    onStepClick,
    maxStepReached = 4
}) => {

    // Helper to determine circle class
    const getCircleClass = (isStepCompleted, isActive) => {
        if (isStepCompleted) return 'completed';
        if (isActive) return 'active';
        return '';
    };

    // Step 1 Logic
    const isDataHandlingActive = currentStep === 'DataHandling' || ['Validation', 'FraudAnalysis', 'Triaging', 'ClaimsSetup'].includes(currentStep);
    // Step 2 Logic
    const isValidationActive = ['Validation', 'FraudAnalysis', 'Triaging', 'ClaimsSetup'].includes(currentStep);
    // Step 3 Logic
    const isFraudAnalysisActive = ['FraudAnalysis', 'Triaging', 'ClaimsSetup'].includes(currentStep);
    // Step 4 Logic
    const isTriagingActive = ['Triaging', 'ClaimsSetup'].includes(currentStep);
    // Step 5 Logic
    const isClaimsSetUpActive = currentStep === 'ClaimsSetup';

    return (
        <div className="progress-stepper-container mb-1">
            <div className="progress-stepper-box">
                {/* Progress Bar Background */}


                <div className="progress-steps-wrapper">
                    {/* Progress Bar Background */}
                    <div className="progress-bar-background">
                        <div
                            className="progress-bar-fill"
                            style={{
                                width: `${Math.min(maxStepReached * 25, 100)}%`
                            }}
                        />
                    </div>
                    {/* Step 1: Data Handling (Index 0) */}
                    <div className="progress-step-item">
                        <div
                            className={`progress-step-action ${maxStepReached >= 0 ? 'clickable' : ''}`}
                            onClick={() => maxStepReached >= 0 && onStepClick && onStepClick('DataHandling')}
                        >
                            <div className={`step-circle ${getCircleClass(isCompleted, isDataHandlingActive)}`}>
                                {isCompleted ? (
                                    <span className="step-check-mark">✓</span>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <div className={`step-label ${currentStep === 'DataHandling' ? 'current' : ''}`}>
                                Data Handling
                            </div>
                        </div>
                    </div>

                    {/* Step 2: Validation (Index 1) */}
                    <div className="progress-step-item">
                        <div
                            className={`progress-step-action ${maxStepReached >= 1 ? 'clickable' : ''}`}
                            onClick={() => maxStepReached >= 1 && onStepClick && onStepClick('Validation')}
                        >
                            <div className={`step-circle ${getCircleClass(isValidationCompleted, isValidationActive)}`}>
                                {isValidationCompleted ? (
                                    <span className="step-check-mark">✓</span>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <div className={`step-label ${currentStep === 'Validation' ? 'current' : ''}`}>
                                Validation
                            </div>
                        </div>
                    </div>

                    {/* Step 3: Fraud Analysis (Index 2) */}
                    <div className="progress-step-item">
                        <div
                            className={`progress-step-action ${maxStepReached >= 2 ? 'clickable' : ''}`}
                            onClick={() => maxStepReached >= 2 && onStepClick && onStepClick('FraudAnalysis')}
                        >
                            <div className={`step-circle ${getCircleClass(isFraudAnalysisCompleted, isFraudAnalysisActive)}`}>
                                {isFraudAnalysisCompleted ? (
                                    <span className="step-check-mark">✓</span>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <div className={`step-label ${currentStep === 'FraudAnalysis' ? 'current' : ''}`}>
                                Fraud Analysis
                            </div>
                        </div>
                    </div>

                    {/* Step 4: Triaging (Index 3) */}
                    <div className="progress-step-item">
                        <div
                            className={`progress-step-action ${maxStepReached >= 3 ? 'clickable' : ''}`}
                            onClick={() => maxStepReached >= 3 && onStepClick && onStepClick('Triaging')}
                        >
                            <div className={`step-circle ${getCircleClass(isTriagingCompleted, isTriagingActive)}`}>
                                {isTriagingCompleted ? (
                                    <span className="step-check-mark">✓</span>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <div className={`step-label ${currentStep === 'Triaging' ? 'current' : ''}`}>
                                Assignment
                            </div>
                        </div>
                    </div>

                    {/* Step 5: Claims Set Up (Index 4) */}
                    <div className="progress-step-item">
                        <div
                            className={`progress-step-action ${maxStepReached >= 4 ? 'clickable' : ''}`}
                            onClick={() => maxStepReached >= 4 && onStepClick && onStepClick('ClaimsSetup')}
                        >
                            <div className={`step-circle ${getCircleClass(isClaimsSetUpCompleted, isClaimsSetUpActive)}`}>
                                {isClaimsSetUpCompleted ? (
                                    <span className="step-check-mark">✓</span>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <div className={`step-label ${currentStep === 'ClaimsSetup' ? 'current' : ''}`}>
                                Claims Set Up
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgressStepper;